import { render, staticRenderFns } from "./change_password.vue?vue&type=template&id=57945c7a&"
import script from "./change_password.vue?vue&type=script&lang=js&"
export * from "./change_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports